import { Post } from "./common";

export default class StatsService {
  static getSellerCounts = async (token: string) =>
    await Post({ path: "stats/seller/counts", token });

  static getSellerBidsYearly = async (token: string, data: any) =>
    await Post({ path: "stats/seller/yearly-bids", token, body: data });

  static getSellerSalesYearly = async (token: string, data: any) =>
    await Post({ path: "stats/seller/yearly-sales", token, body: data });

  static getBuyerCounts = async (token: string) =>
    await Post({ path: "stats/buyer/counts", token });

  static getBuyerBidsYearly = async (token: string, data: any) =>
    await Post({ path: "stats/buyer/yearly-bids", token, body: data });

  static getCounts = async (token: string) =>
    await Post({ path: "stats/counts", token });

  static getChartAdsByDate = async (token: string, data: any) =>
    await Post({ path: "stats/ads-by-date", token, body: data });

  static getChartAdsByBrand = async (token: string, data: any) =>
    await Post({ path: "stats/ads-by-brand", token, body: data });

  static getChartAdsByBodyType = async (token: string) =>
    await Post({ path: "stats/ads-by-body-type", token });

  static getChartAdsByCity = async (token: string, data: any) =>
    await Post({ path: "stats/ads-by-city", token, body: data });

  static getChartUsersByDate = async (token: string, data: any) =>
    await Post({ path: "stats/users-by-date", token, body: data });

  static getChartUsersByCity = async (token: string, data: any) =>
    await Post({ path: "stats/users-by-city", token, body: data });
}
